export default "__VITE_ASSET__BhxtCCur__"